/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
import axios from 'axios';
import params from 'jquery-param';
import Swal from 'sweetalert2';
import { LogError, SessionPopUpReminder, getSessionRemainngTime } from '../AppUtil/AppUtil';
import Session from '../Service/Session';
import i18n from '../i18n';
import ApiService from './ApiService';

const AppConfig = window.AppConfig;
const BUX_URLS = window.AppConfig.BUX_URLS;
const VERIFICATION_URLS = window.AppConfig.VERIFICATION;
const BUX = 'bux';
const BUX_VERIFICATION = 'verification';
const API_URLS = window.AppConfig.API_URLS;
const ACCOUNTS = 'accounts';

export default class BuxService {
	static async buxAuthToken() {
		const requestBody = {
			grant_type: 'multiwallet'
		};
		const response = await ApiService.PostData(API_URLS.ACCOUNTS, requestBody, ACCOUNTS);
		if (!response) {
			LogError('Bux Token generation failed');
			return;
		}
		const data = typeof response === 'object' ? JSON.parse(response.data) : JSON.parse(response).data;
		Session.store('BUX_AUTH_TOKEN', data.access_token);
	}

	static async buxCreateWallet(requestBody) {
		return this.PostData(BUX_URLS.CREATE, requestBody, BUX, BUX);
	}

	static async buxSubmitKyc(requestBody) {
		return this.PostData(BUX_URLS.KYC, requestBody, BUX, BUX);
	}

	static async getWalletBallance() {
		const current_user_info = await Session.get('CURRENT_USER_INFO');
		if (!current_user_info.profile.wallet_connected) {
			return false;
		}
		const email = current_user_info.profile.email;
		return this.GetData(`${BUX_URLS.BALANCES}?email=${email}`, BUX);
	}

	static async getKycStatus() {
		const current_user_info = await Session.get('CURRENT_USER_INFO');
		const email = current_user_info.profile.email;
		return this.GetData(`${BUX_URLS.KYC}?${params({ sub_email: email })}`, BUX);
	}

	static async getEmailAuthToken() {
		const requestBody = {
			emailAddress: AppConfig.BUX_EMAIL_AUTH.BUX_EMAIL_ADDRESS,
			password: AppConfig.BUX_EMAIL_AUTH.BUX_PASSWORD,
			apiKey: AppConfig.BUX_EMAIL_AUTH.BUX_API_KEY
		};
		return this.PostData(VERIFICATION_URLS.EMAIL_TOKEN_GENERATION, requestBody, BUX_VERIFICATION, 'none');
	}

	static async sendEmailVerification(requestBody) {
		return this.PostData(VERIFICATION_URLS.VALIDATE, requestBody, BUX_VERIFICATION, BUX_VERIFICATION);
	}

	static async getEmailVerify(requestBody) {
		return this.PostData(VERIFICATION_URLS.VERIFY, requestBody, BUX_VERIFICATION, BUX_VERIFICATION);
	}

	static async buxWalletTopup(requestBody) {
		return this.PostData(BUX_URLS.TOPUP, requestBody, BUX, BUX);
	}

	static async GetData(url, base = 'default') {
		try {
			const URL = AppConfig.API_URL[base] + url;
			await this.buxAuthToken();
			const params = {};
			params.headers = {
				Authorization: `Bearer ${Session.getByKey('BUX_AUTH_TOKEN')}`
			};
			const response = await axios.get(URL, params);

			return response.data;
		} catch (err) {
			LogError(err.message);
			if (this.checkIfSessionExpired(err.message)) {
				this.logout('app_message.session_expired', 'app_message.session_expired_message');
			}
			return err;
		}
	}

	// Call the function to display the remaining time

	static async PostData(url, data, base = 'default', urlKey = BUX) {
		try {
			const URL = AppConfig.API_URL[base] + url;
			await this.buxAuthToken();
			const params = {};
			if (urlKey === BUX) {
				params.headers = {
					Authorization: `Bearer ${Session.getByKey('BUX_AUTH_TOKEN')}`
				};
			} else if (urlKey === BUX_VERIFICATION) {
				params.headers = {
					Authorization: `Bearer ${Session.getByKey('EMAIL_AUTH_TOKEN')}`
				};
			}
			const response = await axios.post(URL, data, params);
			return response.data;
		} catch (err) {
			LogError(err.message);
		}
	}

	static async getBanks() {
		return this.GetData(BUX_URLS.FETCH_BANKS, BUX);
	}

	static async buxCreateBank(requestBody) {
		return this.PostData(BUX_URLS.CREATE_BANK, requestBody, BUX, BUX);
	}

	static async buxPayoutOtp(requestBody) {
		return this.GetData(`${BUX_URLS.PAYOUT_OTP}?${params(requestBody)}`, BUX);
	}

	static async buxPayout(requestBody) {
		return this.PostData(BUX_URLS.PAYOUT, requestBody, BUX, BUX);
	}

	static async buxPayoutStatus(params) {
		return this.GetData(`${BUX_URLS.PAYOUT}?req_id=${params.req_id}&sub_email=${params.sub_email}`, BUX);
	}

	static logout(title, message) {
		const getTitle = title =>
			i18n.t(title) === 'app_message.session_expired' ? 'Session Expired!' : i18n.t(title);

		const getText = message =>
			i18n.t(message) === 'app_message.session_expired_message'
				? 'Please login again to renew your session.'
				: i18n.t(message);

		Swal.fire({
			title: getTitle(title),
			text: getText(message),
			icon: 'warning',
			customClass: 'otp_message_success'
		}).then(() => {
			window.location.href = '/logout';
		});
	}

	static checkIfSessionExpired(message) {
		return message.indexOf('401') > -1 || message.indexOf('Unauthorized') > -1 || message.indexOf('403') > -1;
	}
}
